const e=(e,t)=>{if(t<=0)throw new Error("pageSize must be positive");const r=[];for(let o=0,s=e.length;o<s;o+=t)r.push(e.slice(o,o+t));return r};export{e as paginateArray};
